import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

const data = [
  { 'Concentration (mg/mL)': 0, 'Signal': 0.095 },
  { 'Concentration (mg/mL)': 0.125, 'Signal': 0.162 },
  { 'Concentration (mg/mL)': 0.25, 'Signal': 0.258 },
  { 'Concentration (mg/mL)': 0.5, 'Signal': 0.407 },
  { 'Concentration (mg/mL)': 1, 'Signal': 0.673 },
  { 'Concentration (mg/mL)': 2, 'Signal': 1.164 },
];

function calculateTrendline(data) {
  // Calcul de la régression linéaire (pente et ordonnée à l'origine)
  let sumX = 0;
  let sumY = 0;
  let sumXY = 0;
  let sumX2 = 0;
  const n = data.length;

  data.forEach((point) => {
    sumX += point['Concentration (mg/mL)'];
    sumY += point['Signal'];
    sumXY += point['Concentration (mg/mL)'] * point['Signal'];
    sumX2 += point['Concentration (mg/mL)'] ** 2;
  });

  const slope = (n * sumXY - sumX * sumY) / (n * sumX2 - sumX ** 2);
  const intercept = (sumY - slope * sumX) / n;

  return { slope, intercept };
}

function Figure7() {
  const trendline = calculateTrendline(data);

  return (
    <div>
      <br></br>
      <u>Figure 7: Concentration </u>
      <LineChart width={600} height={300} data={data} margin={{ top: 20, right: 30, left: 20, bottom: 10 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="Concentration (mg/mL)" type="number" scale="linear" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Line type="monotone" dataKey="Signal" stroke="blue" name="Signal" />
        {/* Ajouter la ligne de tendance en utilisant les valeurs calculées et spécifier le nom "Trendline" */}
        <Line type="linear" dataKey={(entry) => trendline.slope * entry['Concentration (mg/mL)'] + trendline.intercept} stroke="red" name="Trendline" />
      </LineChart>
    </div>
  );
}

export default Figure7;
